
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.875 2.375c-.026.703-.338 1.25-.938 1.64-.624.313-1.25.313-1.874 0-.6-.39-.912-.937-.938-1.64.026-.703.339-1.25.938-1.64.624-.313 1.25-.313 1.874 0 .6.39.912.937.938 1.64zm0 16.25c-.026.703-.338 1.25-.938 1.64-.624.313-1.25.313-1.874 0-.6-.39-.912-.937-.938-1.64.026-.703.339-1.25.938-1.64.624-.313 1.25-.313 1.874 0 .6.39.912.937.938 1.64zm-10-6.25c-.703-.026-1.25-.338-1.64-.938-.313-.624-.313-1.25 0-1.874.39-.6.937-.912 1.64-.938.703.026 1.25.339 1.64.938.313.624.313 1.25 0 1.874-.39.6-.937.912-1.64.938zM21 10.5c-.026.703-.338 1.25-.938 1.64-.625.313-1.25.313-1.875 0-.599-.39-.911-.937-.937-1.64.026-.703.338-1.25.938-1.64.625-.313 1.25-.313 1.875 0 .599.39.911.937.937 1.64zM6.586 17.57c-.52.495-1.12.651-1.797.47-.703-.183-1.146-.626-1.328-1.33-.182-.676-.026-1.275.469-1.796.52-.495 1.12-.651 1.797-.469.677.209 1.12.651 1.328 1.328.182.678.026 1.276-.47 1.797zm0-11.484c-.52.495-1.12.651-1.797.469-.703-.209-1.146-.651-1.328-1.328-.182-.678-.026-1.276.469-1.797.52-.521 1.132-.703 1.836-.547.703.208 1.145.664 1.328 1.367.182.703.013 1.315-.508 1.836zm8.828 11.484c-.495-.52-.651-1.12-.469-1.797.209-.677.651-1.12 1.328-1.328.678-.182 1.276-.026 1.797.47.495.52.651 1.119.47 1.796-.183.703-.626 1.146-1.33 1.328-.676.182-1.275.026-1.796-.469z","fill":"#2B4BFF"}})])
          )
        }
      }
    